<template>
  <div class="sign-contract">
    <div class="height-box" ref="hei_box"></div>
    <div class="sign-contract-wrap">
      <img class="bg-img" src="@static/images/sign/contract-bg.png" />
      <div class="sign-title">{{ userInfo.orgName }}邀请您签署</div>
      <div class="sign-title">《{{ userInfo.name }} 入职合同》</div>
      <div class="sign-sub">
        签字务必一笔一画，工整书写，不要连笔，<br />
        否则审核不通过
      </div>
    </div>
    <div class="contract-btn" :class="{ 'ok-style': $tools.isOKbao(stepConfig.merchantNo) || $tools.isOKTX(stepConfig.merchantNo) }" @click="getContractDetail">
      去签署
    </div>
  </div>
</template>
<script>
import login from './components/login.js';
//ios回退前进缓存
let browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
if (browserRule.test(navigator.userAgent)) {
  window.onpageshow = function (event) {
    if (event.persisted) {
      console.log('ios缓存刷新');
      //如果是从缓存中读取，则重新刷新页面
      window.location.reload();
    }
  };
}
export default {
  name: 'indexBox',
  mixins: [login],
  props: ['stepConfig'],
  data() {
    return {
      signUrl: '',
      userInfo: {}
    };
  },
  computed: {},
  mounted() {
    this.checkLogin().then(() => {
      this.getUserInfo();
    });
  },

  methods: {
    getUserInfo() {
      this.$http({
        type: 'POST',
        url: '/api/userAuth/v2/detail',
        data: {
          token: localStorage.regToken,
          orgId: this.$route.query.orgId
        }
      })
        .then(data => {
          this.userInfo = data.data;
        })
        .catch(err => {});
    },
    getContractDetail() {
      let loadings = this.$notice.loading('加载中...');
      this.$http({
        type: 'POST',
        url: 'api/userAuth/v2/signContract',
        data: {
          token: localStorage.regToken
        }
      })
        .then(data => {
          this.$notice.close(loadings);
          if (data.data) {
            this.signUrl = data.data;
            location.href = this.signUrl;
          }
        })
        .catch(() => {
          this.$notice.close(loadings);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.sign-contract-wrap {
  // margin-top: 20px;
  border-top: 20px solid #f5f7fa;
  text-align: center;
  .bg-img {
    width: 340px;
    margin-top: 96px;
    margin-bottom: 60px;
  }
  .sign-title {
    font-weight: 600;
    font-size: 32px;
    color: #333333;
    line-height: 46px;
  }
  .sign-sub {
    font-size: 28px;
    color: #333333;
    line-height: 42px;
    margin-top: 30px;
  }
}
.contract-btn {
  position: fixed;
  bottom: 54px;
  left: 30px;
  width: calc(100vw - 60px);
  height: 80px;
  background-color: #236dff;
  color: #fff;
  border-radius: 80px;
  text-align: center;
  line-height: 80px;
  font-size: 32px;
}
.ok-style {
  background-color: #ff8b00;
}
</style>
